/* eslint-disable no-unused-vars */
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LoginAppNextLogoSmall } from 'assets/icons';
import { Loader, Buttons } from 'components';
import { authAPI } from 'services/newPlatformAuth.service';
import { showPolipop } from 'utils';

import * as S from './WelcomePage.styled';

export const WelcomePage = () => {
  const [activateUserAction, result] = authAPI.useActivateUserMutation();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const guid = queryParams.get('guid');

  useEffect(() => {
    activateUserAction({ guid });
  }, []);

  useEffect(() => {
    if (result.isError) {
      navigate('/');
    }
  }, [result.isError]);

  if (result.isLoading || result.status === 'uninitialized')
    return (
      <S.Box>
        <Loader.Local delay={100} />
      </S.Box>
    );

  if (result.isSuccess && !result.isError)
    return (
      <S.Box>
        <S.WelcomeBox>
          {result.isLoading && (
            <S.LoaderBox>
              <Loader.Local delay={100} />
            </S.LoaderBox>
          )}
          <LoginAppNextLogoSmall />
          <S.Title>Welcome to Appnext!</S.Title>
          <S.Paragraph>
            Thank you for confirming your email address.
            <br />
            Your account is now fully activated.
            <br />
            You can now log in and start using your account.
          </S.Paragraph>
          <Buttons.PrimaryNormal
            style={{ width: '100%', marginTop: '24px' }}
            onClick={() => navigate('/userLogin')}
          >
            Login
          </Buttons.PrimaryNormal>
        </S.WelcomeBox>
      </S.Box>
    );
};
